import { Component, OnInit } from '@angular/core';
import { PhoneNumbersService } from '../phone-numbers.service';
import { ActivatedRoute } from '@angular/router';
import { AccountSettingsService } from "../../my-account/account-settings.service";
import { PlanWithLimits } from "../../shared/models/plans";

@Component({
  selector: 'cc-custom-phone-number',
  templateUrl: './custom-phone-number.component.html',
  styleUrls: ['./custom-phone-number.component.scss']
})
export class CustomPhoneNumberComponent implements OnInit {
  public msisdn;
  public plan: PlanWithLimits;

  constructor(private phoneNumbersService: PhoneNumbersService, private route: ActivatedRoute,     private accountSettingsService: AccountSettingsService) {}

  ngOnInit() {
    const phoneNumberId = Number(this.route.snapshot.paramMap.get('id'));
    this.phoneNumbersService
      .getPhoneNumbers()
      .subscribe(
        (phoneNumbers: any[]) => (this.msisdn = phoneNumbers.find(phoneNumber => phoneNumber.id === phoneNumberId))
      );
    this.accountSettingsService.currentPlan().subscribe(plan => {
      this.plan = plan;
    });
  }
}
